import { useQuery } from '@tanstack/react-query';

import { getOrder } from '~/services/OrdersService';

export const orderQueryKeys = {
  all: ['order'] as const,
  details: () => [...orderQueryKeys.all, 'detail'] as const,
  detail: (orderId: string) => [...orderQueryKeys.details(), orderId] as const,
};

export function useGetOrder(orderId: string, enabled = true) {
  return useQuery({
    queryKey: orderQueryKeys.detail(orderId),
    queryFn: async () => getOrder(orderId),
    enabled: !!orderId && enabled,
    staleTime: 60_000,
    retry: false,
  });
}
